import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';
import { SourceBook } from "@dndModels";

import NonFSIndex from "@dndComponents/NonFSIndex";
import SourceBookCopyTool from "@dndComponents/SourceBookCopyTool";

import API from "@utilities/smart_api";
import { User } from '@models';

const api = API.getInstance();

export default function SourceBookIndex() {
  const [users, setUsers] = useState<User[]>([]);
  useEffect(() => {
    if (api.user && api.user.is_admin) {
      api.getUsers().then((users) => {
        setUsers(users);
      });
    }
  }, []);
  // debugger;
  return (
    <Grid container spacing={0} direction="row">
      <Grid size={12}>
        <SourceBookCopyTool />
      </Grid>
      <Grid size={12}>
        <NonFSIndex
          data_type="source_book"
          // log_it
          quick_fields={["source_book_type","public","third_party","ua","owned","shared"]}
          extra_filter={(obj) => {
            if (obj instanceof SourceBook) {
              if (obj.is_public || // Shows all the public source books
                (api.user && (
                  api.user.source_book_ids.includes(obj._id) || // Shows all the source books the user has access to, either because they own them or because they're shared with them.
                  api.user.is_admin // Admins can see them.
                )) 
              ) {
                return true;
              }
            }
            return false;
          }}
          extra_details={(obj) => {
            if (obj instanceof SourceBook && api.user && obj.owner_id !== "") {
              if (obj.owner_id === api.user._id) {
                return "Owner";
              } else if (api.user.is_admin) {
                // debugger;
                const owner = users.find(user => user._id === obj.owner_id);
                return `Owned by ${owner ? owner.name : "Unknown"}`;
              }
            }
            return "";
          }}
        />
      </Grid>
    </Grid>
  );
}
